import clone from 'lodash/clone';
import keyBy from 'lodash/keyBy';
import omit from 'lodash/omit';

import * as util from '../../util/merge';
import api from '../../store/config/api';
import { ADD_REMINDER_SUCCESS } from '../../actions/api/reminder';
import {
  GET_USER_SUCCESS,
  UPDATE_USER_SUCCESS,
  DELETE_USER_SUCCESS
} from '../../actions/api/user';
import { GET_USERS_SUCCESS } from '../../actions/api/users';
import {
  GET_AUTH_INFO_SUCCESS,
  GET_TEAM_SUCCESS,
  UPDATE_TEAM_SUCCESS
} from '../../actions/api/team';
import { GET_INTEGRATIONS_SUCCESS } from '../../actions/api/integrations';
import { GET_APPS_SUCCESS } from '../../actions/api/apps/';
import { GET_APP_CONTACT_SUCCESS } from '../../actions/api/apps/contact';
import { AUTHENTICATION_SUCCESS } from '../../actions/api/auth';
import {
  GET_TASK_SUCCESS,
  ADD_TASK_SUCCESS,
  UPDATE_TASK_SUCCESS,
  COMPLETE_TASK_SUCCESS
} from '../../actions/api/task';
import {
  GET_STEP_SUCCESS,
  ADD_STEP_SUCCESS,
  UPDATE_STEP_SUCCESS,
  DELETE_STEP_SUCCESS
} from '../../actions/api/step';
import {
  GET_STEPS_SUCCESS,
  UPDATE_STEPS_SUCCESS
} from '../../actions/api/steps';
import {
  GET_TASKS_SUCCESS,
  GET_USER_TASKS_SUCCESS,
  UPDATE_TASKS_SUCCESS
} from '../../actions/api/tasks';
import {
  GET_FILTERS_SUCCESS,
  ADD_FILTER_SUCCESS
} from '../../actions/api/filter';
import {
  ADD_INVITE_SUCCESS,
  GET_INVITE_SUCCESS,
  ACCEPT_INVITE_SUCCESS
} from '../../actions/api/invite';
import { GET_RUN_SUCCESS, UPDATE_RUN_SUCCESS } from '../../actions/api/run';
import {
  ADD_INTEGRATION_SUCCESS,
  DELETE_INTEGRATION_SUCCESS,
  GET_INTEGRATION_SUCCESS
} from '../../actions/api/integration';
import { GET_WEBFORM_SUCCESS } from '../../actions/api/webform';
import { GET_WEBHOOK_SUCCESS } from '../../actions/api/webhook';
import { GET_WEBHOOKS_SUCCESS } from '../../actions/api/webhooks';
import {
  GET_PREDICTOR_SUCCESS,
  CREATE_PREDICTOR_SUCCESS,
  UPDATE_PREDICTOR_SUCCESS,
  DELETE_PREDICTOR_SUCCESS
} from '../../actions/api/predictor';
import { GET_PREDICTORS_SUCCESS } from '../../actions/api/predictors';
import { GET_PROCESSES_SUCCESS } from '../../actions/api/processes';
import { GET_SEARCH_RESULTS_SUCCESS } from '../../actions/api/search';
import {
  GET_NOTIFICATIONS_SUCCESS,
  READ_NOTIFICATION_SUCCESS
} from '../../actions/api/notifications';
import { GET_GROUP_SUCCESS } from '../../actions/api/group';
import { GET_GROUPS_SUCCESS } from '../../actions/api/groups';
import { GET_TRIGGER_SUCCESS } from '../../actions/api/trigger';
import {
  GET_TRIGGERS_SUCCESS,
  GET_TRIGGERS_FOR_PROCESS_SUCCESS
} from '../../actions/api/triggers';
import {
  GET_FILE_OBJECT_SUCCESS,
  GET_FILE_SUCCESS,
  ADD_FILE_SUCCESS
} from '../../actions/api/file';
import {
  GET_PROCESS_FIELDS_SUCCESS,
  GET_VISIBLE_FIELDS_SUCCESS
} from '../../actions/api/fields';
import {
  GET_PROCESS_SUCCESS,
  ADD_PROCESS_SUCCESS,
  UPDATE_PROCESS_SUCCESS
} from '../../actions/api/process';
import { GET_RUNS_SUCCESS } from '../../actions/api/runs';
import {
  GET_THREAD_LIST_SUCCESS,
  GET_THREAD_SUCCESS
} from '../../actions/api/thread';
import {
  ADD_MESSAGE_SUCCESS,
  GET_MESSAGE_BODY_SUCCESS
} from '../../actions/api/message';
import { ADD_COMMENT_SUCCESS } from '../../actions/api/comment';
import {
  GET_TABLE_SUCCESS,
  ADD_TABLE_SUCCESS,
  UPDATE_TABLE_SUCCESS,
  IMPORT_TABLE_SUCCESS
} from '../../actions/api/table';
import { GET_TABLES_SUCCESS } from '../../actions/api/tables';
import { GET_TABLE_ROWS_SUCCESS } from '../../actions/api/tableRows';
import {
  UPDATE_FIELD_SUCCESS,
  ADD_FIELD_SUCCESS,
  DELETE_FIELD_SUCCESS
} from '../../actions/api/field';
import {
  GET_CREDENTIAL_SUCCESS,
  ADD_CREDENTIAL_SUCCESS,
  UPDATE_CREDENTIAL_SUCCESS,
  DELETE_CREDENTIAL_SUCCESS
} from '../../actions/api/credential';
import { GET_CREDENTIALS_SUCCESS } from '../../actions/api/credentials';

import * as schemas from '../../schemas';
import * as fieldUtils from '../../util/fields';
import * as processFields from './processFields';
const { GET_TRANSACTION_SUCCESS } = api;

const DEFAULT_STATE = Object.keys(schemas)
  .filter(k => schemas[k].key) // eslint-disable-line import/namespace
  .reduce(
    (o, k) => ({
      ...o,
      [schemas[k].key]: {} // eslint-disable-line import/namespace
    }),
    {}
  );

export default function entities(state = DEFAULT_STATE, action) {
  // eslint-disable-next-line no-unused-vars
  let newState, newProcesses;

  switch (action.type) {
    case ADD_REMINDER_SUCCESS:

    case GET_TEAM_SUCCESS: // eslint-disable-line no-fallthrough
    case UPDATE_TEAM_SUCCESS:

    case GET_USER_SUCCESS: // eslint-disable-line no-fallthrough
    case UPDATE_USER_SUCCESS:
    case GET_USERS_SUCCESS:

    case GET_APPS_SUCCESS: // eslint-disable-line no-fallthrough
    case GET_APP_CONTACT_SUCCESS:
    case GET_INTEGRATIONS_SUCCESS:
    case GET_INTEGRATION_SUCCESS:
    case ADD_INTEGRATION_SUCCESS:

    case GET_TASK_SUCCESS: // eslint-disable-line no-fallthrough
    case ADD_TASK_SUCCESS:
    case UPDATE_TASK_SUCCESS:
    case COMPLETE_TASK_SUCCESS:
    case GET_TASKS_SUCCESS:
    case GET_USER_TASKS_SUCCESS:
    case GET_TRANSACTION_SUCCESS:

    case GET_INVITE_SUCCESS: // eslint-disable-line no-fallthrough
    case ADD_INVITE_SUCCESS:
    case ACCEPT_INVITE_SUCCESS:

    case GET_AUTH_INFO_SUCCESS: // eslint-disable-line no-fallthrough

    case AUTHENTICATION_SUCCESS:
    case GET_WEBFORM_SUCCESS:
    case GET_WEBHOOK_SUCCESS:

    case GET_PROCESS_SUCCESS: // eslint-disable-line no-fallthrough
    case ADD_PROCESS_SUCCESS:
    case UPDATE_PROCESS_SUCCESS:
    case GET_PROCESSES_SUCCESS:

    case GET_STEPS_SUCCESS: // eslint-disable-line no-fallthrough
    case GET_STEP_SUCCESS:
    case ADD_STEP_SUCCESS:
    case UPDATE_STEP_SUCCESS:

    case GET_RUN_SUCCESS: // eslint-disable-line no-fallthrough
    case GET_RUNS_SUCCESS:
    case UPDATE_RUN_SUCCESS:

    case GET_FILE_OBJECT_SUCCESS: // eslint-disable-line no-fallthrough
    case GET_FILE_SUCCESS:
    case ADD_FILE_SUCCESS:

    case GET_THREAD_SUCCESS: // eslint-disable-line no-fallthrough
    case GET_THREAD_LIST_SUCCESS:

    case ADD_MESSAGE_SUCCESS: // eslint-disable-line no-fallthrough
    case ADD_COMMENT_SUCCESS:
    case GET_NOTIFICATIONS_SUCCESS:
    case READ_NOTIFICATION_SUCCESS:
    case GET_TRIGGER_SUCCESS:
    case GET_TRIGGERS_FOR_PROCESS_SUCCESS:
    case GET_GROUP_SUCCESS:
    case GET_GROUPS_SUCCESS:

    case GET_SEARCH_RESULTS_SUCCESS: // eslint-disable-line no-fallthrough
    case UPDATE_STEPS_SUCCESS:

    case GET_TABLE_SUCCESS: // eslint-disable-line no-fallthrough
    case ADD_TABLE_SUCCESS:
    case UPDATE_TABLE_SUCCESS:
    case IMPORT_TABLE_SUCCESS:
    case GET_TABLES_SUCCESS:

    case GET_PREDICTORS_SUCCESS: // eslint-disable-line no-fallthrough
    case GET_PREDICTOR_SUCCESS:
    case CREATE_PREDICTOR_SUCCESS:
    case UPDATE_PREDICTOR_SUCCESS:

    case GET_FILTERS_SUCCESS: // eslint-disable-line no-fallthrough
    case ADD_FILTER_SUCCESS:

    case GET_CREDENTIAL_SUCCESS: // eslint-disable-line no-fallthrough
    case GET_CREDENTIALS_SUCCESS:
    case ADD_CREDENTIAL_SUCCESS:
    case UPDATE_CREDENTIAL_SUCCESS:

    case ADD_FIELD_SUCCESS: // eslint-disable-line no-fallthrough
    case UPDATE_FIELD_SUCCESS:
      return util.merge(state, action.response.entities);

    case GET_TABLE_ROWS_SUCCESS:
      return {
        ...state,
        fields: {
          ...state.fields,
          ...(action.response.entities || {}).fields
        },
        tableRows: {
          ...state.tableRows,
          ...(action.response.entities || {}).tableRows
        }
      };
    case DELETE_USER_SUCCESS:
      const newUsers = omit(state.users, action.response.result);
      return { ...state, users: newUsers };
    case DELETE_INTEGRATION_SUCCESS:
      const newIntegrations = omit(state.integrations, action.response.result);
      return { ...state, integrations: newIntegrations };
    case DELETE_STEP_SUCCESS:
      const stepID = schemas.getIDFromSchema(schemas.STEP, action.payload);
      const newSteps = omit(state.steps, stepID);
      return { ...state, steps: newSteps };
    case DELETE_CREDENTIAL_SUCCESS:
      const newCredentials = omit(state.credentials, action.response.result);
      return { ...state, credentials: newCredentials };
    case GET_PROCESS_FIELDS_SUCCESS:
      return processFields.getProcessFieldsSuccess(state, action);
    case GET_MESSAGE_BODY_SUCCESS:
      const splitUrl = action.payload.url.split('/');
      const messageID = splitUrl[splitUrl.length - 2];
      return {
        ...state,
        messages: {
          ...(state.messages || {}),
          [messageID]: {
            ...(state.messages[messageID] || {}),
            body: action.response.body
          }
        }
      };
    case UPDATE_TASKS_SUCCESS:
      const newTasks = clone(action.response.entities);
      delete newTasks.tasks.undefined;
      return util.merge(state, newTasks);
    case GET_TRIGGERS_SUCCESS:
      const newTriggers = clone(action.response.entities.triggers);
      return { ...state, triggers: newTriggers };
    case GET_WEBHOOKS_SUCCESS:
      const newWebhooks = clone(action.response.entities.webhooks);
      return {
        ...state,
        webhooks: newWebhooks
      };
    case GET_VISIBLE_FIELDS_SUCCESS:
      const visibleFieldMap = keyBy(action.response, 'fieldID');
      const visibleFields = util.merge(state.visibleFields, visibleFieldMap);
      return util.merge(state, { visibleFields });
    case DELETE_FIELD_SUCCESS:
      const deletedField =
        action.response.entities.fields[action.response.result];
      const allFieldVersions = fieldUtils.getAllFieldVersionsForField(
        deletedField,
        state.fields
      );
      const nextFields = omit(
        state.fields,
        allFieldVersions.map(f => f.fieldID)
      );
      return { ...state, fields: nextFields };
    case DELETE_PREDICTOR_SUCCESS:
      const nextPredictors = omit(state.predictors, action.predictorID);
      return { ...state, predictors: nextPredictors };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/entities/entities.js